export enum EFileType {
  IMAGE = "image",
  AUDIO = "audio",
  DOCUMENT = "document",
  SPREADSHEET = "spreadsheet",
  COMPRESSED = "compressed",
  VIDEO = "video",
  UNKNOWN = "unknown",
}
